import { useRouter } from 'next/router';

import { useTracker, ZigzagEvent } from '@common/log-manager';
import { gotoShopHome, useCatalogProductIdParams, usePdpBaseInfo, usePdpConfig } from '@domains/pdp-common';

export const useShopLinkService = () => {
  const params = useCatalogProductIdParams();
  const { product, shop, brand_home } = usePdpBaseInfo(params);
  const { isZigzagApp } = usePdpConfig();
  const router = useRouter();
  const tracker = useTracker();
  const seller_home = brand_home ?? shop;

  const handleClickShop = () => {
    if (!isZigzagApp) {
      tracker.sendImmediately({
        category: 'click',
        navigation: 'product_detail',
        object_section: 'top_section',
        object_type: 'button',
        object_id: 'shop_home',
        data: { shop_id: seller_home.id, catalog_product_id: product.id },
      });
      router.push(`/${seller_home.main_domain}?pdp_product_id=${product.id}`);
      return;
    }

    ZigzagEvent.subl({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'top_section',
      object_type: 'button',
      object_id: 'shop_home',
      data: JSON.stringify({ shop_id: seller_home.id, catalog_product_id: product.id }),
    });

    gotoShopHome(seller_home.main_domain, seller_home.url, 'product_detail');
  };

  return {
    handleClickShop,
    shop_name: seller_home.name ?? '',
  };
};
